import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'

/**
 * Import
 * - Actions
 */
import { getNotifications } from '../../../actions'
import { readNotifications } from '../../../actions'

import Notifications from '../../../components/common/Notifications/Notifications'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        notifications: state.notifications,
    }
}

export default connect(mapStateToProps, {
    getNotifications: getNotifications,
    readNotifications: readNotifications,
})(Notifications)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/common/Notifications/Notifications.tsx